"use client";

import { cn } from "@/utils/cn";
import type { HeroSlide } from "@consts/images";
import Image from "next/image";
import { type CSSProperties, useEffect, useState } from "react";

interface Props {
	slides: HeroSlide[];
}

const SLIDE_INTERVAL_MS = 3200;

export default function HeroSlideshow({ slides }: Props) {
	const [activeIndex, setActiveIndex] = useState(0);

	useEffect(() => {
		if (slides.length < 2) return;

		const timer = setInterval(() => {
			setActiveIndex((index) => (index + 1) % slides.length);
		}, SLIDE_INTERVAL_MS);

		return () => clearInterval(timer);
	}, [slides.length]);

	return (
		<div aria-hidden className="absolute inset-0">
			{slides.map(({ image, focus }, index) => (
				<Image
					key={image.src}
					src={image}
					placeholder="blur"
					alt=""
					fill
					sizes="100vw"
					// Фото на весь экран — здесь сжатие заметнее всего
					quality={100}
					preload={index === 0}
					style={
						focus ? ({ "--focus": focus } as CSSProperties) : undefined
					}
					className={cn(
						"object-cover transition-opacity duration-1000 ease-in-out max-lg:[object-position:var(--focus,center)]",
						index === activeIndex ? "opacity-100" : "opacity-0"
					)}
				/>
			))}
		</div>
	);
}
